import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class SvgIconsModule {
  materialIconsPath = 'app/grid/svg-icons/icons';

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'add',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/add.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chevron-down',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chevron-down.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chevron-up',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chevron-up.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'close',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/close.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'content-copy',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/content-copy.svg`
      )
    ),
      iconRegistry.addSvgIcon(
        'content-save',
        sanitizer.bypassSecurityTrustResourceUrl(
          `${this.materialIconsPath}/content-save.svg`
        )
      );
    iconRegistry.addSvgIcon(
      'delete',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/delete.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'drag-indicator',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/drag-indicator.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'north',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/north.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'palette',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/palette.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'sort-ascending',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/sort-ascending.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'sort-descending',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/sort-descending.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'south',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/south.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'sort-numeric',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/sort-numeric.svg`
      )
    );
  }
}
